<template>
	<svg :style="style">
		<path :fill="fillColor" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
	</svg>
</template>


<script>

export default {
	props:['fill','size'],
	data() {
		return {
			width:24,
			height:24,
			fillColor:'#000',
		}
	},
	computed:{
		style(){
			return 'width:'+this.width+'px; height:'+this.height+'px;'
		}
	},
	mounted(){
		if(this.fill) this.fillColor = this.fill;
		if(this.size) {
			this.width = parseInt(this.size);
			this.height = parseInt(this.size);
		}
	}
}

</script>

<style scoped>
	svg { display: inline-block; animation: spin linear infinite .6s; }

	@keyframes spin {
		0%{transform: rotate(0deg)}
		100%{transform: rotate(360deg)}
	}
</style>
